import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const apiClient = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export interface RoadmapResponse {
  id: string;
  assessmentId: string;
  timeline: {
    days30: TimelinePhase;
    days60: TimelinePhase;
    days90: TimelinePhase;
  };
  milestones: Milestone[];
  budgetBreakdown: BudgetBreakdown;
  selectedRecommendation: any;
  estimatedTotalCost: number;
  estimatedROI: string;
  riskAssessment: string[];
  status: string;
  createdAt: string;
}

export interface TimelinePhase {
  title: string;
  tasks: string[];
}

export interface Milestone {
  id: number;
  title: string;
  description: string;
  dueDate: string;
  deliverable: string;
  status: 'pending' | 'in_progress' | 'completed';
}

export interface BudgetBreakdown {
  development: BudgetItem;
  infrastructure: BudgetItem;
  training: BudgetItem;
  maintenance: BudgetItem;
}

export interface BudgetItem {
  amount: number;
  description: string;
}

export const roadmapService = {
  generateRoadmap: async (
    assessmentId: string, 
    selectedRecommendation: any
  ): Promise<RoadmapResponse> => {
    const response = await apiClient.post('/roadmap/generate', {
      assessmentId,
      selectedRecommendation
    });
    return response.data.data;
  },

  getRoadmap: async (roadmapId: string): Promise<RoadmapResponse> => {
    const response = await apiClient.get(`/roadmap/${roadmapId}`);
    return response.data.data;
  },

  updateRoadmapStatus: async (
    roadmapId: string, 
    status: string
  ): Promise<RoadmapResponse> => {
    const response = await apiClient.patch(`/roadmap/${roadmapId}/status`, {
      status
    });
    return response.data.data;
  }
};

// Add response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Roadmap API Error:', error);
    
    if (error.response) {
      const message = error.response.data?.error?.message || 'Errore nella gestione della roadmap';
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Errore di connessione. Verifica la tua connessione internet.');
    } else {
      throw new Error('Errore imprevisto. Riprova tra qualche minuto.');
    }
  }
);